import { Fragment } from "react";
import hpAboutInner from "../img/hp_about_2_inner-min.jpg";
import hpAboutGeorgia from "../img/hp_about_georgia_inner.jpg";
import promoText from "../img/promo_text-sm_en.svg";
import promoTextXs from "../img/promo_text-xs_en.svg";
import promoTextGeorgia from "../img/web/welcome-georgia.svg";
import promoTextGeorgiaXs from "../img/web/welcome-ge-xs.svg";

const homePageData = {
    en: [
        {
            id: "123",
            img: hpAboutGeorgia,
            title: "Find your treasure",
            description: "Raise the anchor of your imagination and set sail with us to discover the taste of eternal youth. Each of our candies conceals a different story!",
            link: "/products#tangy-jelly",
            buttonName: <Fragment>Explore candy <span>islands</span></Fragment>,
        },
        {
            id: "124",
            img: hpAboutInner,
            title: "I, Captain Candy",
            description: <Fragment>Discover a story full of adventure,<br />suspense and knowledge</Fragment>,
            link: "/captain-story",
            buttonName: <Fragment>My story</Fragment>,
        },
    ],
    ka: [
        {
            id: "123",
            img: hpAboutGeorgia,
            title: "იპოვე შენი საგანძური!",
            description: "გაშალე წარმოსახვის იალქნები და ჩვენთან ერთად გაცურე ტკბილი თავგადასავლების სამყაროში. ჩვენი თითოეული კანფეტი თავის უნიკალურ ისტორიას მალავს!",
            link: "/products#tangy-jelly",
            buttonName: <Fragment>აღმოაჩინე ტკბილი <span>კუნძულები!</span></Fragment>,
        },
        {
            id: "124",
            img: hpAboutInner,
            title: "მე, კაპიტანი Candy",
            description: <Fragment>აღმოაჩინე თავგადასავლებით, <br />იდუმალი ამბებით და საოცარი აღმოჩენებით სავსე ისტორია</Fragment>,
            link: "/captain-story",
            buttonName: <Fragment>ჩემი ამბავი</Fragment>,
        },
    ],
};

const promoTextHeader = {
    en: {
        text: "test",
        promoText: promoText,
        promoTextXs: promoTextXs,
    },
    ka: {
        text: "მოგესალმებით ბორტზე",
        promoText: promoTextGeorgia,
        promoTextXs: promoTextGeorgiaXs,
    }
};

export {
    homePageData,
    promoTextHeader,
};
